export const roomKeys = {
    DISCONNECTED: 'disconnected',
    DOMINANT_SPEAKER_CHANGED: 'dominantSpeakerChanged',
    PARTICIPANT_CONNECTED: 'participantConnected',
    PARTICIPANT_DISCONNECTED: 'participantDisconnected',
    RECONNECTED: 'reconnected',
    RECONNECTING: 'reconnecting',
    TRACK_PUBLISHED: 'trackPublished',
    TRACK_UNPUBLISHED: 'trackUnpublished',
}
